import { fetchPaymentType, fetchShippingMethod, fetchDueDays } from "@hub/order/src/services/contract.service"
export default {
  fillContract({ commit }, contract) {
    commit("setAdditives", contract.additives)
    if (contract.accession) {
      const formattedAccession = {
        text: contract.accession?.name,
        value: contract.accession?.uuid,
        installments: contract.accession?.installments
      }
      commit("setAccession", formattedAccession)
    }
    commit("updateContractType", contract.contract_type)
    commit("updateShipping", contract.shipping)
    commit("updateDueDate", contract.dueDate)
    commit("updatePayment", contract.payment)
    commit("Order/Billing/setBank", contract.bank, { root: true })
    commit("Order/Billing/setBankName", contract.bankName, { root: true })
    commit("Order/Billing/setAgency", contract.agency, { root: true })
    commit("Order/Billing/setAccount", contract.account, { root: true }),
    commit("updateContractExternalId", contract.contractId)
    commit("updateContractPersonExternalId", contract.personalExternalId)
  },
  createAdditive({ state }) {
    state.additives.push({ text: "Selecione...", value: 0 })
  },
  deleteAdditive({ state }, index) {
    state.additives.splice(index, 1)
  },
  async fetchPaymentTypesOptions({ getters, commit }) {
    if (getters.getPaymentTypesOptions && getters.getPaymentTypesOptions?.length) {
      return
    }

    try {
      const data = await fetchPaymentType()
      commit("setPaymentTypesOptions", data)
    } catch (error) {
      console.error(error)
    }
  },

  async fetchShippingMethodsOptions({ getters, commit }) {
    if (getters.getShippingMethodsOptions && getters.getShippingMethodsOptions?.length) {
      return
    }

    try {
      const data = await fetchShippingMethod()
      commit("setShippingMethodsOptions", data)
    } catch (error) {
      console.error(error)
    }
  },

  async fetchDueDaysOptions({ getters, commit }) {
    if (getters.getDueDaysOptions && !!getters.getDueDaysOptions?.length && getters.getDueDaysOptions?.length > 1) {
      return
    }

    try {
      const data = await fetchDueDays()
      commit("setDueDaysOptions", data)
    } catch (error) {
      console.error(error)
    }
  },

  async fetchContractOptionIfNecessary({ dispatch }) {
    await Promise.all([
      dispatch("fetchPaymentTypesOptions"),
      dispatch("fetchShippingMethodsOptions"),
      dispatch("fetchDueDaysOptions")
    ])
  },

  resetContract ({ commit }) {
    commit("resetContract")
    commit("Order/Billing/resetBilling", null, { root: true })
  },
}
